import React from "react"

import * as S from "./footer.styles"
import data from "./footer.json"
import { Grid } from "@mui/material"

const Footer = ({ className, hideFooter }) => {
  return (
    <>
      {!hideFooter && (
        <S.Wrapper maxWidth="lg" className={className}>
          <S.InnerWrapper>
            <S.Flex container>
              <div className="left">
                <a className="phone" href={`tel:${data.phone}`}>
                  <div className="booking">{data.booking}</div>
                  <div className="phone">{data.phone}</div>
                </a>
              </div>
              <div item className="middle">
                <S.Disclaimer>{data.disclaimer}</S.Disclaimer>
              </div>
              <div className="right">
                <p className="address">{data.address}</p>
              </div>
            </S.Flex>
          </S.InnerWrapper>
        </S.Wrapper>
      )}
    </>
  )
}

export default Footer
